import styled, { css } from 'styled-components';

const textSize = {
  h1: 56,
  h2: 44,
  h3: 38,
  h4: 24,
  h5: 20,
  h6: 16,
  h7: 14,
  h8: 12,
  b1: 56,
  b2: 44,
  b3: 38,
  b4: 24,
  b5: 20,
  b6: 16,
  b7: 14,
  b8: 12,
};

const text = css`
  font-size: ${({ $fontSize, $type }) =>
    ($fontSize && `${$fontSize / 16}rem`) || ($type && `${textSize[$type] / 16}rem`)};
  font-weight: ${({ $fontWeight, $type }) =>
    $fontWeight || ($type?.includes('h') && 700) || ($type?.includes('b') && 400) || 500};
  color: ${({ $color, theme }) => theme.colors[$color] || $color || theme.colors.strong};
  line-height: ${({ $lineHeight, $type }) => $lineHeight || ($type?.includes('1' || '2' || '3') && 1.2) || '1.5'};
  ${({ $textAlign }) => $textAlign && `text-align:${$textAlign}`};
  ${({ $whiteSpace }) => $whiteSpace && `white-space: ${$whiteSpace}`};
  ${({ $letterSpacing }) => $letterSpacing && `letter-spacing: ${$letterSpacing}px`};
  ${({ $wordBreak }) => $wordBreak && `word-break: ${$wordBreak}`};
  ${({ $wordWrap }) => ($wordWrap && `word-wrap: ${$wordWrap}`) || 'pre-line'};
  ${({ $maxLine }) =>
    $maxLine &&
    `
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: ${$maxLine};
    -webkit-box-orient: vertical;
    `};

  @media ${({ theme }) => theme.device.tablet} {
    font-size: ${({ $tFontSize, $tType }) =>
      ($tFontSize && `${$tFontSize / 16}rem`) || ($tType && `${textSize[$tType] / 16}rem`)};
    line-height: ${({ $tLineHeight, $tType }) => $tLineHeight || ($tType?.includes('1' || '2' || '3') && 1.2) || '1.5'};
  }
  @media ${({ theme }) => theme.device.mobile} {
    font-size: ${({ $mFontSize, $mType }) =>
      ($mFontSize && `${$mFontSize / 16}rem`) || ($mType && `${textSize[$mType] / 16}rem`)};
  }
`;

export const Text = styled.p`
  ${text}
`;

export const Span = styled.span`
  ${text}
`;

export const Pre = styled.pre`
  ${text}
`;